<template>
    <v-container class="fill-height pa-4" fluid>
        <v-row justify="center" align="center">
            <v-col cols="12" sm="9" md="6" lg="4" xl="3">
                <v-card class="pa-6" rounded="lg" elevation="3">
                    <div class="text-overline grey--text mb-3">DG Ventures</div>

                    <template v-if="submitted">
                        <div class="text-h4 mb-2">✅</div>
                        <div class="text-h6 font-weight-bold mb-1">Request submitted</div>
                        <p class="text-body-2 grey--text text--darken-1 mb-0">
                            Thanks, {{ form.name.split(' ')[0] }}. We'll email you at {{ form.email }} once your
                            request has been reviewed.
                        </p>
                    </template>

                    <template v-else>
                        <div class="text-h6 font-weight-bold mb-1">Request an account</div>
                        <p class="text-body-2 grey--text text--darken-1 mb-4">
                            You'll need an approved account to view the floor plan. Fill this in and we'll get back
                            to you by email.
                        </p>

                        <v-form ref="form" v-model="valid" @submit.prevent="submit">
                            <v-text-field v-model="form.name" label="Full name" outlined dense
                                :rules="[required]" class="mb-1" />
                            <v-text-field v-model="form.email" label="Email" outlined dense
                                :rules="emailRules" class="mb-1" />
                            <v-text-field v-model="form.phone" label="Phone" outlined dense
                                :rules="[required]" class="mb-1" />
                            <v-select v-model="form.role_id" :items="roles" item-text="name" item-value="id"
                                label="Primary role" outlined dense :rules="[required]" :loading="loadingOptions"
                                class="mb-1" />
                            <v-autocomplete v-model="form.company_id" :items="companies" item-text="name" item-value="id"
                                label="Company" outlined dense :rules="[required]" :loading="loadingOptions"
                                class="mb-1" />

                            <v-btn color="primary" depressed block class="text-none mt-2" :loading="submitting"
                                :disabled="!valid" type="submit">
                                Submit request
                            </v-btn>
                        </v-form>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'RequestAccountComponent',
    data() {
        return {
            valid: false,
            loadingOptions: true,
            submitting: false,
            submitted: false,
            roles: [],
            companies: [],
            form: {
                name: '',
                email: '',
                phone: '',
                role_id: null,
                company_id: null,
            },
            emailRules: [
                v => !!v || 'Email is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
        };
    },
    mounted() {
        document.title = 'DG Tasks - Request Account';
        this.loadFormOptions();
    },
    methods: {
        required(v) {
            return !!v || 'Required';
        },
        async loadFormOptions() {
            try {
                const { data } = await this.$axios.get('api/account-requests/form-options');
                if (data && data.response) {
                    this.roles = data.roles || [];
                    this.companies = data.companies || [];
                }
            } catch (e) {
                this.$toast.error('Could not load the form. Please refresh and try again.');
            } finally {
                this.loadingOptions = false;
            }
        },
        async submit() {
            if (!this.$refs.form.validate()) return;
            this.submitting = true;
            try {
                const { data } = await this.$axios.post('api/account-requests', this.form);
                if (data && data.response) {
                    this.submitted = true;
                } else {
                    this.$toast.error((data && data.message) || 'Could not submit your request.');
                }
            } catch (e) {
                const message = e.response && e.response.data && e.response.data.message;
                this.$toast.error(message || 'Could not submit your request.');
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>
